import { Injectable } from '@angular/core';

import { VgHlsSupportService } from '../VgHlsSupport.Service';

import { HlsUtilService } from 'vbrick-player-src/HlsUtil.Service';
import { IVbSource } from 'vbrick-player-src/IVbSource';
import { userAgentUtil } from 'vbrick-player-src/UserAgentUtil';

import {
	VG_CONFERENCE_DUAL_HLS_TYPE,
	VG_CONFERENCE_DUAL_PLAYBACK_EXTENSION
} from './DualHlsConstants';

@Injectable() //'vgConferenceDualHlsService'
export class VgConferenceDualHlsService {
	constructor(
		private HlsUtilService: HlsUtilService,
		private VG_HLS_SUPPORT: VgHlsSupportService
	) {}

	public getRealSrc(src: string): string { //extension provides a way for playback plugins to differentiate between dual vs. normal hls playback, but internally we swap it out with .m3u8
		return src.replace(VG_CONFERENCE_DUAL_PLAYBACK_EXTENSION, '.m3u8');
	}

	public isMulticast(src: string, type: string): boolean {
		return this.HlsUtilService.isMulticast(this.getRealSrc(src), type);
	}

	public isPlaybackSupported(source: IVbSource): boolean {
		const { src, type } = source;

		return !userAgentUtil.isMobile && //not a mobile device AND
			this.VG_HLS_SUPPORT.isMSE && //Media Source Extensions is supported
			type === VG_CONFERENCE_DUAL_HLS_TYPE && //supplied type is what we're looking for AND
			!this.HlsUtilService.isMixedContent(src) && //not a mixed content scenario (in which case Flash playback will be used)
			!this.HlsUtilService.isUnsupportedRevConnectSource(source) && // not a rev connect source in an unsupported environment
			!this.isUnsupportedMulticastSource(src, type) && // not a mutlicast source in an unsupported environment
			this.getRealSrc(src).includes('.m3u8'); //expected master playlist file name is present in the src
	}

	public isUnsupportedMulticastSource(src: string, type: string): boolean {
		const realSrc: string = this.getRealSrc(src);

		// it is multicast AND playback is unsupported in this environment
		return this.isMulticast(realSrc, type) &&
			!this.HlsUtilService.isMulticastPlaybackSupported(realSrc, type);
	}
}
